import React from 'react';
import { showHideScreenSize } from '../actions/ShowHide';
import connect from 'react-redux/es/connect/connect';
import { SidebarMenu } from '../components/Elements';
import { dropShowHide } from '../actions/dropShowHide';
import { Drawer } from '@material-ui/core';

const SideBarContainer = (props) => {
  const { showHideScreenSize, desktop, dark } = props;
  /* const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent); */
  const iOS =
    typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);
  return (
    <Drawer
      anchor={window.innerWidth >= 768 ? 'left' : 'top'}
      open={desktop}
      elevation={1000}
      style={{ zIndex: 1000 }}
      onClose={() => showHideScreenSize(!desktop)}
      onOpen={() => showHideScreenSize(!desktop)}
      transitionDuration={200}
      swipeAreaWidth={30}
      disableBackdropTransition={!iOS}
      disableDiscovery={true}
    >
      <SidebarMenu colors={dark ? '#001C41' : '#EEEEEE'} {...props} />
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  desktop: state.menu.desktop,
  dropDown: state.dropDown.show,
  dark: state.dark,
});

export default connect(mapStateToProps, { showHideScreenSize, dropShowHide })(
  SideBarContainer,
);
